<div class="apm-select apm-multiselect">
  <ng-select
    [(ngModel)]="selectedValue"
    [placeholder]="('444720' | apmTranslate) ?? ''"
    [notFoundText]="('444722' | apmTranslate) ?? ''"
    [items]="results()"
    [multiple]="multiple()"
    [addTag]="addTag()"
    [clearable]="clearable()"
    [searchable]="searchable()"
    [disabled]="disabled()"
    [bindLabel]="bindLabel()"
    [bindValue]="bindValue()"
    [hideSelected]="true"
    [editableSearchTerm]="true"
    [minTermLength]="minLengthTerm()"
    [loading]="resultsLoading()"
    [typeahead]="searchInput$"
    [virtualScroll]="virtualScroll()"
    (ngModelChange)="onValueChange($event)"
    typeToSearchText="{{
      minLengthTerm() === 1 ? ('444724' | apmTranslate) : ('444723' | apmTranslate: [minLengthTerm()])
    }}"
    addTagText="{{ '444732' | apmTranslate }}"
  ></ng-select>
</div>
